export class Servizio{
    public uuid: string;
    public slug: string;
    public titolo: string;
    public anteprima: string;
    public testo: string;
    public immagine_lancio: string;
    public documenti: Array<string>;
    public immagini: Array<string>;
    public logo: string;
    public colore:string;
    public path_immagine:string;
    public path_logo:string;
    public ordine:number; //orderBy
    public lang: string;
    public documento: string;

    constructor(){

    }
}